function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.658 10.34l2.73-2.73a.966.966 0 00-1.367-1.367l-2.73 2.73 1.367 1.366zM15.776 14.78l2.729-2.73a.966.966 0 10-1.367-1.367l-2.729 2.73 1.367 1.366z",
  fill: "#F6F8FC"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.497 22.941c5.767 0 10.442-4.674 10.442-10.441 0-5.766-4.675-10.441-10.442-10.441-5.526 0-10.05 4.294-10.417 9.727L0 12.243C.137 5.458 5.68 0 12.497 0c6.904 0 12.5 5.596 12.5 12.5S19.401 25 12.497 25a12.476 12.476 0 01-9.718-4.637l1.516-1.401.026.032 2.673-2.673a5.15 5.15 0 011.667-7.64l7.523 7.524a5.15 5.15 0 01-7.473 1.787l-2.694 2.695a10.397 10.397 0 006.48 2.254z",
  fill: "#F6F8FC"
});

var SvgBespokenDefaultPluginIcon = function SvgBespokenDefaultPluginIcon(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgBespokenDefaultPluginIcon;